import { Currency, type CurrencyProps } from './Currency';
import { CurrencyConnected, type CurrencyConnectedProps } from './CurrencyConnected';

/** @deprecated use @pp/core/src/components/currency/Currency */
const DeprecatedCurrency = Currency;
/** @deprecated use @pp/core/src/components/currency/CurrencyConnected */
const DeprecatedCurrencyConnected = CurrencyConnected;

export { DeprecatedCurrency as Currency, DeprecatedCurrencyConnected as CurrencyConnected };
export type { CurrencyProps, CurrencyConnectedProps };
